<script setup>
import { RHDHVHeader } from '@haskoning/vue-component-library'

const router = useRouter()
const authStore = useAuthStore()
const projectStore = useProjectStore()
const uiStore = useUiStore()

const {
  currentItem: currentProject
} = storeToRefs(projectStore)

const goToProjectIndex = () => {
  router.push({ name: 'project-index' })
}

async function logout() {
  await authStore.logout()
  await authStore.$patch({
    user: null
  })
  await router.push({ name: 'auth-login' })
}

// This workaround is needed to make the top-right icon name abbreviation work properly
// The RHDHVHeader component assumes that users have first_name and last_name property, which feathers does not send
const fixUserFirstNameAndLastName = computed(() => {
  const user = authStore.$state?.user
  if(!user) {
    return null
  }
  user.first_name = user.firstName
  user.last_name = user.lastName
  return user
})
</script>

<template>
  <RHDHVHeader
      title="AIS"
      image-src="/logo-rhdhv-white.png"
      :user="fixUserFirstNameAndLastName"
      @logo-click="goToProjectIndex"
      @logout="logout()"
  >
    <template v-slot:toolbar-prepend>
      <v-app-bar-nav-icon
          class="pl-4 mx-1 no-overlay"
          height="36"
          width="36"
          color="white"
          :ripple="false"
          :icon="uiStore.sideBarState ? 'mdi-close' : 'mdi-menu'"
          @click="uiStore.toggleSideBar"
      />
    </template>
    <template v-slot:breadcrumbs-items v-if="$route.name?.startsWith('project-')">
      <v-breadcrumbs-item>
        <router-link
            class="text-white toolbar-text text-decoration-none"
            :to="{ name: 'project-index' }"
        >
          Projects
        </router-link>
      </v-breadcrumbs-item>

      <template v-if="currentProject?._id && $route.name !== 'project-index'">
        <v-breadcrumbs-divider />
        <v-breadcrumbs-item>
          <router-link
              class="text-white toolbar-text text-decoration-none"
              :to="{ name: 'project-info', params: { id: $route.params.id } }"
          >
            {{ currentProject?.name }}
          </router-link>
        </v-breadcrumbs-item>
      </template>
    </template>

    <template v-slot:breadcrumbs-items v-if="$route.name?.startsWith('user-')">
      <v-breadcrumbs-item>
        <router-link
            class="text-white toolbar-text text-decoration-none"
            :to="{ name: 'user-index' }"
        >
          Users
        </router-link>
      </v-breadcrumbs-item>
    </template>

    <template v-slot:breadcrumbs-items v-if="$route.name?.startsWith('polygon-')">
      <v-breadcrumbs-item>
        <router-link
            class="text-white toolbar-text text-decoration-none"
            :to="{ name: 'polygon-index' }"
        >
          Polygons
        </router-link>
      </v-breadcrumbs-item>
    </template>

    <template v-slot:breadcrumbs-items v-if="$route.name?.startsWith('exported-data-index')">
      <v-breadcrumbs-item>
        <router-link
            class="text-white toolbar-text text-decoration-none"
            :to="{ name: 'exported-data-index' }"
        >
          Data exports
        </router-link>
      </v-breadcrumbs-item>
    </template>

    <template v-slot:breadcrumbs-items v-if="$route.name?.startsWith('terms-and-conditions')">
      <v-breadcrumbs-item>
        <router-link
            class="text-white toolbar-text text-decoration-none"
            :to="{ name: 'exported-data-index' }"
        >
          Terms and Conditions
        </router-link>
      </v-breadcrumbs-item>
    </template>

    <template v-slot:breadcrumbs-items v-if="$route.name?.startsWith('settings-')">
      <v-breadcrumbs-item>
        <router-link
            class="text-white toolbar-text text-decoration-none"
            :to="{ name: 'settings-index' }"
        >
          Settings
        </router-link>
      </v-breadcrumbs-item>

      <template v-if="$route.name === 'settings-roles'">
        <v-breadcrumbs-divider />
        <v-breadcrumbs-item>
          <router-link
              class="text-white toolbar-text text-decoration-none"
              :to="{ name: 'settings-roles' }"
          >
            Roles
          </router-link>
        </v-breadcrumbs-item>
      </template>
    </template>
  </RHDHVHeader>
</template>

<style scoped>
.no-overlay :deep(.v-btn__overlay) {
  display: none;
}
</style>